import { tr } from 'i18n';
import { useTranslation as useInterfaceLanguage } from 'react-i18next';

import LogoutIcon from '@mui/icons-material/Logout';
import PersonIcon from "@mui/icons-material/Person";

import ChangeBackground from "components/ChangeBackground/ChangeBackground";
import BackgroundModal from "hooks/BackgroundModal/BackgroundModal";
import { useEffect, useState } from "react";
import { PieChart } from "react-minimal-pie-chart";

import { useNavigate } from "react-router-dom";
import DynamicUserInfo from "utils/DynamicUserInfo";
import Notification from "utils/Notifications";
import userInfo from "utils/userInfo";
import styles from "./PersonalMenu.module.scss";
import PersonalInfo from "./components/PersonalInfo";
import statistik from "assets/icons/pie-chart.png";

import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getUserAvatarUrl } from 'components/Erp/UserAvatar';

import lock from "assets/side_pane_new_icons/lock.png";
function PersonalMenuCard({ userId, setBackground }) {
  useInterfaceLanguage();
  const location = useLocation();
 
  const [openBackground, setOpenBackground] = useState(false);


  const [currentDynamicUser, getDynamic] = useState();
  const currentUser = useSelector(state => state.user);
  const currentPhoto = getUserAvatarUrl(currentUser) || currentDynamicUser?.imeag;
  const [EfficiencyColor, setEfficiencyColor] = useState("grey");

  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });
  const user = userInfo();
 

  const navigate = useNavigate();
 



  

 

  const [isExpanded, setIsExpanded] = useState(false);

  const handleClickImg = () => {
    setIsExpanded(!isExpanded);
  };

  const handleExit = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("task");
    localStorage.removeItem("user");
    localStorage.removeItem("background");
    localStorage.removeItem("subscription");

    const socket = new WebSocket("wss://inn.onoxo.ru/ws/online_status/");

    socket.onopen = () => {
      socket.send(
        JSON.stringify({ command: "disconnect", user_id: user?.userId })
      );
      socket.close();
    };

    navigate("/");
  };

  const dataOrders = [
    { title: tr("Завершенные"), value: 70, color: "var(--theme-warning-text, #FFB03A)" },
    {
      title: tr("В процессе выполнения"),
      value: user.efficiency,
      color: "var(--theme-success-text, #18AF55)",
    },
  ];

  useEffect(() => {
    if (dataOrders[1].value <= 40) {
      setEfficiencyColor("red");
    } else if (dataOrders[1].value <= 80) {
      setEfficiencyColor("#FFB03A");
    } else if (dataOrders[1].value > 80) {
      setEfficiencyColor("#18AF55");
    }
  }, [dataOrders[1].value]);

  var currentURL = window.location.pathname;
  var regex = /^\/$/;
  // background
  const backgroundImage = localStorage.getItem("background");
  setBackground(backgroundImage);



  return (
    <>
      {tr(isExpanded && (
        <div className={styles.avatar_img2} onClick={handleClickImg}>
          <img
            src={currentPhoto}
            alt={tr("Фото профиля в полном размере")}
            style={{
              cursor: "pointer",
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: 9999,
              maxWidth: "380px",
              maxHeight: "380px",
              borderRadius: "6px",
              
            }}
          />
        </div>
      ))}

      <div className={styles.profile_wrapper}>
        <div className={styles.personal_info}>
          <div className={styles.user_avatar}>
            <img
              src={currentPhoto}
              alt={tr("Фото профиля")}
              onClick={handleClickImg}
              style={{ cursor: "pointer" }}
              className={styles.user_avatar_img}
            />{" "}
            <div className={styles.user_name}>
              <span>
                {tr(user?.firstName)} {tr(user?.surName)}
              </span>
              <br />
              <span style={{ color: "color-mix(in srgb, var(--theme-text-muted, rgb(82, 92, 105)) 70.2%, transparent)", fontSize: "13px" }}>
                {tr(user?.position)}
              </span>
              <br />
            </div>
          </div>

          <div className={styles.user_online}>{tr("В сети")}</div>
        </div>

        <div
          style={{ border: `0.5px solid ${EfficiencyColor}` }}
          className={styles.Efficiency}
        >
          <div className={styles.single_pie}>
            <div className={styles.pie_size}>
              <PieChart
                animate
                animationDuration={1000}
                animationEasing="ease-in"
                center={[40, 40]}
                data={dataOrders}
                lengthAngle={360}
                lineWidth={21}
                paddingAngle={0}
                radius={25}
                startAngle={0}
                label={null}
                labelPosition={80}
                labelStyle={{
                  fontSize: "12px",
                  fontColor: "FFFFFA",
                  fontWeight: "800",
                }}
                style={{
                  width: "50px",
                  heigth: "50px",
                  marginTop: "5px",
                  marginLeft: "10px",
                }}
              />
            </div>
            <span>{tr(user.efficiency)}%</span>
          </div>
          <div>
            {" "}
            <span>{tr("Эффективность")}</span>
          </div>
        </div>
        <div className={styles.wallpaper_block}>
          {user?.them ? (
            <div
              style={{
                backgroundImage: `url(${backgroundImage})`,
                backgroundSize: "cover",
              }}
              className={styles.change_wallpaper}
            >
              {" "}
              <img src={lock} className={styles.img} alt=""></img>
              <span style={{ color: "var(--theme-text, black)" }}>{tr("Тема оформления")}</span>
            </div>
          ) : (
            <div
              style={{
                backgroundImage: `url(${backgroundImage})`,
                backgroundSize: "cover",
              }}
              className={styles.change_wallpaper}
            >
              <span style={{ color: "white", fontSize: "14px" }}>{tr("Тема оформления")}</span>
              <button
                className={styles.btn_change}
                onClick={() => setOpenBackground(true)}
              >{tr("Изменить")}</button>
            </div>
          )}
        </div>

      
        
      
         {tr(location.pathname !== "/personalcard" && (
            <div onClick={() => navigate("/personalcard")}>
              <PersonalInfo
                icons={
                  <PersonIcon sx={{ fontSize: "18px", marginRight: "5px" }} />
                }
                title={tr("Профиль")}
              />
            </div>
             ))}
       
        <div style={{ padding: "10px 14px" }}>
          <hr />
        </div>
        <div
          className={styles.footer_card_btns}
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          {regex.test(currentURL) ? (
            <div
              style={{ width: "100%", display: "flex", alignItems: "center" }}
              onClick={() => navigate(`/home/`)}
            >
              <PersonalInfo
                icons={
                  <PersonIcon sx={{ fontSize: "18px", marginRight: "5px" }} />
                }
                title={tr("В систему")}
              />
            </div>
          ) : (
            <>
           
            </>
          )}

          <div onClick={handleExit} className={styles.logout}>
            <LogoutIcon sx={{ color: "var(--theme-text-muted, gray)", fontSize:'18px' }} />
            <span>{tr("Выйти")}</span>
          </div>
        </div>
        <DynamicUserInfo
          idEmployee={userId === undefined ? user?.userId : userId}
          getDynamic={getDynamic}
        />
      </div>
      <BackgroundModal
        openModal={openBackground}
        setOpenModal={setOpenBackground}
      >
        <ChangeBackground setOpenModal={setOpenBackground} />
      </BackgroundModal>
      <Notification notify={notify} setNotify={setNotify} />
    </>
  );
}

export default PersonalMenuCard;
